'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var watCookie = require('@quintoandar/wat-cookie');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
require('whatwg-fetch');
function _interopDefaultLegacy(e) {
  return e && _typeof(e) === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty__default['default'](target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
/**
 * Try's to parse string to JSON if it is a JSON string
 * otherwise retuns an empty object
 *
 * @param {string} text JSON string
 *
 * @returns {object}    The parsed JSON from the string
 */

function handleJSON(text) {
  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */

function parseJSON(response) {
  return response.text().then(function (text) {
    return text ? handleJSON(text) : {};
  });
}
/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */

function checkStatus(_x) {
  return _checkStatus.apply(this, arguments);
}
function _checkStatus() {
  _checkStatus = _asyncToGenerator__default['default']( /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee(response) {
    var error;
    return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(response.status >= 200 && response.status < 300)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", response);
          case 2:
            error = new Error(response.statusText);
            error.response = response;
            _context.next = 6;
            return parseJSON(response);
          case 6:
            error.details = _context.sent;
            throw error;
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _checkStatus.apply(this, arguments);
}
function makeXMLHttpRequest(url, options) {
  var xhr = new XMLHttpRequest();
  xhr.upload.addEventListener('progress', function (event) {
    if (event.lengthComputable) {
      options.reportProgress(event.loaded / event.total * 100);
    }
  }, false);
  var promise = new Promise(function (resolve, reject) {
    xhr.onload = function () {
      return resolve(JSON.parse(xhr.responseText));
    };
    xhr.onerror = reject;
  });
  xhr.open(options.method, url);
  xhr.withCredentials = true;
  xhr.send(options.body);
  return promise;
}
/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */

function request(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    method: 'GET'
  };
  if (options.reportProgress) {
    return makeXMLHttpRequest(url, options);
  }
  var prepOptions = Object.assign(options, {
    credentials: 'include'
  });
  return fetch(url, prepOptions).then(checkStatus).then(parseJSON);
}
function externalRequest(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    method: 'GET'
  };
  if (options.reportProgress) {
    return makeXMLHttpRequest(url, options);
  }
  var prepOptions = Object.assign(options);
  return fetch(url, prepOptions).then(checkStatus).then(parseJSON);
}
/**
 * Requests a URL as a POST, returning a promise
 *
 * @param  {string} url            The URL we want to request
 * @param  {object} body           The body of the POST
 * @param  {object} extraHeaders   Any extra headers used for the request
 * @param  {object} extraOptions   Any extra options that might be required
 *
 * @return {object}                The response data
 */

function postRequest(url, body, extraHeaders, extraOptions) {
  var options = buildRequestOptionsJsonBody('POST', body, extraHeaders, extraOptions);
  return request(url, options);
}
var buildRequestOptionsJsonBody = function buildRequestOptionsJsonBody(method, body, extraHeaders, extraOptions) {
  return _objectSpread({
    method: method,
    body: JSON.stringify(body),
    headers: _objectSpread({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, extraHeaders)
  }, extraOptions);
};
var buildQueryStrings = function buildQueryStrings(obj) {
  return Object.keys(obj).map(function (k) {
    return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(obj[k]));
  }).join('&');
};
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty__default['default'](target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
/**
 * @param endpoint
 * @param options
 * @param required If this endpoint only works if the user is authenticated.
 * Default is true and will short-circuit a 403 to avoid an unnecessary call if an auth cookie is absent.
 * If set to false it means that the endpoint also works for unauthenticated users and will not short-circuit
 * @returns {*}
 */

function fetchWithAuth(endpoint, options) {
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var requestOptions = _objectSpread$1({
    credentials: 'include'
  }, options);
  if (required && !watCookie.hasAuthCookie()) {
    var error = new Error('User is not authenticated');
    error.response = {
      status: 403
    };
    return Promise.reject(error);
  }
  return request(endpoint, requestOptions);
}
exports.buildQueryStrings = buildQueryStrings;
exports.buildRequestOptionsJsonBody = buildRequestOptionsJsonBody;
exports.externalRequest = externalRequest;
exports.fetchWithAuth = fetchWithAuth;
exports.postRequest = postRequest;
exports.request = request;